const img = (id, w = 1200) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=${w}&auto=format`;

export const IMAGES = {
  marble: img("photo-1598476543599-72c8a60894d7", 2000),
  lakeside: img("photo-1697638223793-3c7e3dbfb6d0", 1600),
  featureWall: img("photo-1624334823455-d666b43c36c1", 900),
  kitchen: img("photo-1556912167-f556f1f39fdf", 900),
  birchwood: img("photo-1628012209120-d9db7abf7eab", 900),
  cladding: img("photo-1605018075968-b014b8d2e487", 900),
  woodwork: img("photo-1722606509803-4d6cbd5b26bf", 900),
  paving: img("photo-1762810981576-1b07f76af9d2", 1200),
  interior: img("photo-1613545325278-f24b0cae1224", 900),
  dining: img("photo-1613082294483-fec382d8367e", 900),
  exterior: img("photo-1596416702942-c84ff2e686a3", 900),
  commercial: img("photo-1659051600842-7089a15d7f7d", 900),
  cabinet: img("photo-1638885930125-85350348d266", 900),
  mural: img("photo-1757212381351-e8ae9a4239dc", 900),
};
